import styled from '@emotion/styled';
import { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';
import { Text } from '@rebass/emotion';

export const CurrentPrice = styled(Text)<{
  theme: AppTheme;
}>`
  font-family: ${({ theme }) => theme.fonts?.fontBold};
  font-size: ${rem(28)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors?.black};
`;

export const OldPrice = styled(CurrentPrice)<{
  theme: AppTheme;
}>`
  color: ${({ theme }) => theme.colors?.gray};
  text-decoration: line-through;
`;
